import React from "react";
import {
  Box,
  Modal,
  TextField,
  Button,
  Grid,
  Select,
  MenuItem,
  IconButton,
} from "@mui/material";
import TitreGraphik from "../Typography/TitreGraphik";
import LabelTypography from "../Typography/LabelTypography";
import { useTranslation } from "react-i18next";
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { formatDateForMySQL } from "../../services/functions";
import { useEffect, useState } from "react";
import { Api_Token } from "../../util/Api";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", md: "50%" },
  backgroundColor: "white",
  boxShadow: 24,
  p: 4,
};

const ModelJourney = ({
  open,
  onClose,
  formData,
  setFormData,
  handleSubmit,
  error,
  caisseDispo = false,
}) => {
  const { t } = useTranslation();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [Store, setStore] = useState([]);
  useEffect(() => {
    Api_Token.get(`caisses/getAvailableCaisses`).then((response) => {
      setStore(response.data);
    });
  }, []);

  function onCloseIn() {
    setFormData({
      store: "",
      montantDepart: "",
      dateOpen: "",
      dateClose: "",
    });
    onClose();
  }

  return (
    <Modal open={open} onClose={onCloseIn}>
      <Box sx={modalStyle}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TitreGraphik>
              {" "}
              {formData.id ? t("Edit_Journey") : t("Create_New_Journey")}
            </TitreGraphik>
          </Grid>
          <Grid item xs={12}>
            <LabelTypography>
              {formData.id
                ? t("Update the details of this journey.")
                : t("Fill in the details to create a new journey.")}
            </LabelTypography>
          </Grid>
          {caisseDispo && (
            <Grid item xs={12}>
              <Select
                fullWidth
                value={formData.store}
                onChange={handleInputChange}
                required
                name="store"
              >
                <MenuItem value="" disabled>
                  {t("Choose a Caisse")}
                </MenuItem>
                {Store.map((caisse) => (
                  <MenuItem key={caisse.id} value={caisse.id}>
                    {caisse.nomCaisse}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          )}
          <Grid item xs={12}>
            <LabelTypography>{t("Montant Depart")}</LabelTypography>
            <TextField
              name="montantDepart"
              fullWidth
              value={formData.montantDepart}
              onChange={handleInputChange}
              required
              type="number"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <LabelTypography>{t("Date open")}</LabelTypography>

            <TextField
              fullWidth
              type="datetime-local"
              name="dateOpen"
              onClick={() =>
                document.getElementById("date-picker1").showPicker()
              }
              value={formData.dateOpen || ""} // Use an empty string instead of null
              onChange={(event) =>
                setFormData({
                  ...formData,
                  dateOpen: event.target.value, // Extract the value from event
                })
              }
              id="date-picker1"
            />

            {/*<MobileDateTimePicker
              sx={{ color: "blue" }}
              name="dateOpen"
              value={dayjs(formData.dateOpen) || null} // Use null instead of empty string
              onChange={(newValue) =>
                setFormData({
                  ...formData,
                  dateOpen: formatDateForMySQL(newValue),
                })
              }
              renderInput={(params) => <TextField {...params} fullWidth />}
            />*/}
          </Grid>
          <Grid item xs={12} md={6}>
            <LabelTypography>{t("Date close")}</LabelTypography>
            <TextField
              fullWidth
              type="datetime-local"
              name="dateClose"
              onClick={() =>
                document.getElementById("date-picker2").showPicker()
              }
              value={formData.dateClose || null} // Use null instead of empty string
              onChange={(event) =>
                setFormData({
                  ...formData,
                  dateClose: event.target.value,
                })
              }
              id="date-picker2"
              //  label="Select Date and Time"
              //  InputLabelProps={{ shrink: true }}
            />
            {/** <MobileDateTimePicker
              name="dateClose"
              value={dayjs(formData.dateClose) || null} // Use null instead of empty string
              onChange={(newValue) =>
                setFormData({
                  ...formData,
                  dateClose: formatDateForMySQL(newValue),
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  error={error}
                  helperText={error}
                />
              )}
            />*/}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" color="error" onClick={onCloseIn}>
                  {t("Cancel")}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                >
                  {formData.id ? t("Update") : t("Create")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModelJourney;
